/**
 * External dependencies
 */
import { createSelector } from 'reselect';
import { get, find, map, sortBy, reverse } from 'lodash';

/**
 * Internal dependencies
 */
import { getAllCoupons } from 'state/coupons/selectors';
import { getAllAddons } from 'state/addons/selectors';

export const getCurrentDispatchId = (state) => get(state, ['currentDispatch', 'items']);

export const getCurrentDispatch = (state) => {
    return get(state, ['currentDispatch', 'items'], []);
};

export const requestingCurrentDispatch = (state) => get(state, ['currentDispatch', 'requesting'], false);

export const errorRequestingCurrentDispatch = (state) => get(state, ['currentDispatch', 'error'], false);

export const hasScheduledChanges = createSelector(
    getCurrentDispatch,
    (currentDispatch) => {
        return get(currentDispatch, ['has_scheduled_changes'], false);
    },
);
export const getCurrentDispatchPlanId = createSelector(
    getCurrentDispatch,
    (currentDispatch) => {
        return get(currentDispatch, ['plan_id'], null);
    },
);